import * as base64 from "utils/base64";
import { ClientType } from "Apps/shared/ClientHost/type";
const separator = "|";

export interface IClientHostOptions {
    preview?: boolean,
    frameId: string,
    type: string, 
    modal?: boolean,
    autoHeight?: boolean;
    use_scrollbar?: boolean;
    splash?: {
        show_navbar?: boolean;//是否显示导航条(splashpage)或步骤导航(embed),
        show_footer?: boolean;//是否显示底部固定的bar(splashpage第二步),
        detail?: boolean;
    },
    embed?: {
        fit?: boolean,
        skipLanding?: boolean,
    },
    card?: {
        enabled: boolean,
    }
    calendar?: {
        fill?: boolean,
        theme?: 'classic' | 'black' | 'white',
        event?: string
    },
    mobile?: {

    },
    cards?: {
        event?: string
    },
    facebook?: {
        page_id
    },
    filter?: {
        ticket?: string
    }
}


export const defaultOptions: IClientHostOptions = {
    frameId: "none",
    type: null,
    preview: false,
    modal: false,
    autoHeight: false,
    use_scrollbar: true,
    splash: {
        show_navbar: true,
        show_footer: true,
        detail: true
    },
    embed: {
        fit: false
    },
    card: {
        enabled: false
    },
    calendar: {
        fill: false,
        theme: "black"
    },
    mobile: {},
    cards: {},
    filter: {}
}

export function stringify(obj) {
    var str = JSON.stringify(obj);
    return base64.encodeURL(str);
}

export function parse(str): IClientHostOptions {
    var rawStr = base64.decodeURL(str);
    var options = JSON.parse(rawStr);
    return $.extend(true, {}, defaultOptions, options);
}


// WEBPACK FOOTER //
// ./src/Apps/shared/ClientHost/options.ts